import { useSelector } from "react-redux";
import {
  companySettingsSelector,
  formatSettingsSelector,
  instrumentsSettingsSelector,
} from "../store/slice/settings";
import { templateSettingsSelector } from "../store/slice/settings";

/**
 *
 * @returns {import("../..").CompanySetting}}
 */
export const useCompanySettings = () => {
  return useSelector(companySettingsSelector);
};

export const useInstrumentsSetting = () => useSelector(instrumentsSettingsSelector);

/**
 *
 * @returns {import("../..").IFormatSetting}}
 */
export const useFormatSetting = () => useSelector(formatSettingsSelector);

export function useTemplateSetting() {
  return useSelector(templateSettingsSelector);
}
